import { AppRemixIcon } from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import ErrorHandler from '../../../../../components/error/ErrorHandler';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';

const ObligationCheckbox = (props) => {
  const { plantObligationID } = props;
  const dispatch = useDispatch();
  const checkedPlantObligations = useSelector(
    (state) => state.currentPage?.checkedPlantObligations
  );

  // > TOGGLE OBLIGATION CHECKBOX
  const togleCheckbox = async () => {
    const tempCheckedPlantObligations = !checkedPlantObligations
      ? []
      : [...checkedPlantObligations];
    try {
      if (tempCheckedPlantObligations.includes(plantObligationID)) {
        dispatch(
          currentPageAction.change(
            'checkedPlantObligations',
            tempCheckedPlantObligations.filter(
              (cpo) => cpo !== plantObligationID
            ),
            true
          )
        );
      } else {
        tempCheckedPlantObligations.push(plantObligationID);
        dispatch(
          currentPageAction.change(
            'checkedPlantObligations',
            tempCheckedPlantObligations,
            true
          )
        );
      }
    } catch (err) {
      dispatch(ErrorHandler(err, history));
    }
  };
  // < TOGGLE OBLIGATION CHECKBOX

  return (
    <>
      <AppRemixIcon
        className="pointer"
        icon={
          checkedPlantObligations &&
          checkedPlantObligations.includes(plantObligationID)
            ? 'checkbox'
            : 'checkbox-blank'
        }
        size={20}
        onClick={() => togleCheckbox()}
      />
    </>
  );
};

export default ObligationCheckbox;
